import CutSites from 'molbio/enzymes/backbone/CutSites';
import {SequenceLinearMapTabView} from 'molbio/maps/linear/Linear';
import {MiniMapTabView} from 'molbio/maps/linear/MiniMap';

/**
 * This is a stateless global object that is used to keep cutsite information in sync between the Sequence Map
 * and the Linear Map (aka MiniMap). The plasmid map manually sets up its own listeners.
 * Each map calls `CutsiteMap.addListeners` in its own `registerListeners` function and passes the callback
 * that that map needs to fire in order to update its internal representation of cutsite data and rerender
 * cutsites.
 */
const CutsiteMap = {
  addListeners: (
    view: SequenceLinearMapTabView | MiniMapTabView,
    cutsites: CutSites,
    listener: () => void
  ): void => {
    // Both SequenceMap and MiniMap use cutsites, but we don't have multiple inheritance.
    view.listenTo(cutsites, 'cutsitesChanged change:color', listener);
  },
};

export default CutsiteMap;
